import React from 'react';
import { IIconProps } from './utils';

export const ChevronUp = ({
  fill = 'currentColor', height = 30, width = 30, ...rest
} : IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M7.5 18.75L14.1161 12.1339C14.6043 11.6457 15.3957 11.6457 15.8839 12.1339L22.5 18.75"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
